import { render, staticRenderFns } from "./TopElement.vue?vue&type=template&id=5c6c59d3&scoped=true&"
import script from "./TopElement.vue?vue&type=script&lang=js&"
export * from "./TopElement.vue?vue&type=script&lang=js&"
import style0 from "./TopElement.vue?vue&type=style&index=0&id=5c6c59d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6c59d3",
  null
  
)

export default component.exports